<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-check`]" width="1em" height="1em" v-bind="$attrs"><path d="M8 1.10156C11.723 1.10156 14.7412 4.11973 14.7412 7.84277C14.7412 9.61094 14.0591 11.2185 12.9453 12.4209L14.5371 14.0137C14.7966 14.2733 14.7965 14.6944 14.5371 14.9541C14.2775 15.2137 13.8564 15.2136 13.5967 14.9541L11.9473 13.3057C10.8376 14.1087 9.47447 14.584 8 14.584C4.27721 14.5838 1.25891 11.5656 1.25879 7.84277C1.25879 4.11986 4.27714 1.10178 8 1.10156ZM8 2.43164C5.01168 2.43186 2.58887 4.8544 2.58887 7.84277C2.58899 10.831 5.01175 13.2537 8 13.2539C10.9884 13.2539 13.411 10.8312 13.4111 7.84277C13.4111 4.85427 10.9885 2.43164 8 2.43164ZM9.49902 6.15137C9.75877 5.89215 10.1799 5.8928 10.4395 6.15234C10.6987 6.41209 10.698 6.83324 10.4385 7.09277L7.70508 9.82617C7.44539 10.0856 7.02426 10.0857 6.76465 9.82617L5.37012 8.43262C5.11064 8.1731 5.11097 7.75192 5.37012 7.49219C5.6298 7.2325 6.05085 7.23253 6.31055 7.49219L7.23535 8.41504L9.49902 6.15137Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineCheck',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
